module.exports = __webpack_public_path__ + "static/img/accountFrify.025e54b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/accountFrify.svg
// module id = OMq0
// module chunks = 1